// extracted by mini-css-extract-plugin
export var component = "Invoices-module--component--cyFPU";
export var currentBalance = "Invoices-module--currentBalance--sVnIO";
export var currentInvoice = "Invoices-module--currentInvoice--Z4vuW";
export var filter = "Invoices-module--filter--vedkW";
export var label = "Invoices-module--label--iVd-+";
export var previousInvoices = "Invoices-module--previousInvoices--rCn1F";
export var results = "Invoices-module--results--tR6XQ";
export var resultsContent = "Invoices-module--resultsContent--EoJ+o";
export var resultsHeader = "Invoices-module--resultsHeader--cu8HA";
export var resultsTitle = "Invoices-module--resultsTitle--dU6Pr";
export var select = "Invoices-module--select--BXdXx";